import React, { Component } from 'react';
import TravelBudget2Page from './travel-budget2-html';
class TravelBudget2 extends Component {
    constructor(props) {
        super(props)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    render() {
        return (
            <div>
                <TravelBudget2Page
                />
            </div>
        )
    }
}
export default TravelBudget2;